import CAMPAIGN_STATUS_LIST from "@/constants/campaign";

const CampaignHelper = {
  getColorClass(status: string): string {
    const color = CAMPAIGN_STATUS_LIST.find((e) => e.key === status);
    return color ? color.class : "grey";
  },
};

export default CampaignHelper;
